import { Intent } from "@blueprintjs/core";
import { DataTable, FieldSet, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { MetierConseillersLiesApi, MetierConseillersLiesSearch } from "../../../../../api";
import { ERoutes } from "../../../../../AppRouter";
import { EditButton } from "../../../../../components";
import { useTl } from "../../../../../hooks";
import { useApiService } from "../../../../../hooks/useApiService";
import { ETLCodes } from "../../../../../locales";

export interface IMetierConseillersLiesProps {}

export const MetierConseillersLies: React.FunctionComponent<IMetierConseillersLiesProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(MetierConseillersLiesApi);
  const { id } = useParams<{ id: string }>();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [15, 25, 50],
    pageSize: 15,
    sortKeys: { nom: "ASC" }
  });

  const { totalCount } = tableState;

  const searchFunction = React.useCallback(
    (sObj?: MetierConseillersLiesSearch) => {
      sObj.idmetier = +id;
      return api.metierConseillersLiesBaseSearch({ MetierConseillersLiesSearch: sObj });
    },
    [api, id]
  );

  const { loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Nom),
        fieldName: "nom",
        autoFitContent: true
      },
      {
        header: () => t(ETLCodes.Prenom),
        fieldName: "prenom"
      }
    ],
    [t]
  );

  return (
    <FieldSet
      title={t(ETLCodes.TableResults, { count: totalCount })}
      rightElement={
        <EditButton
          onClick={() => history.push(`${ERoutes.metier}/${id}/conseillerslies/selector`)}
          intent={Intent.PRIMARY}
          text={t(ETLCodes.Modify)}
        />
      }
    >
      <DataTable
        dateFormat="dd/MM/yyyy"
        tableState={tableState}
        loading={loading}
        columns={columns}
        filterMode="OnEnter"
      ></DataTable>
    </FieldSet>
  );
};
